// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 8802) return "static/chunks/94726e6d-c72f786ad97421bb.js";
	if (chunkId === 4185) return "static/chunks/4185-b07e73eb5485d3a7.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 296 ? "ea88be26" : chunkId) + "." + {"296":"4031e8dca9c09163","9260":"8b664e9bc0e705da"}[chunkId] + ".js";
};